// Страницы документации «Эквайринг» (main AcquiringController передаёт запросы в catalog AcquiringController;
// шлюзы — PaymentGates, поля фискализации — классы Fiscalization1_05 / Fiscalization1_2 шлюза).
// Методы кабинета: нужен токен входа руководителя.
import type { ApiDocBlock, ApiDocPage } from '../types'

const acquiringResponse = (ffd: string, ffdKeys: string) => `{
  "success": 1,
  "data": {
    "id": 2,
    "name": "Sber",
    "keys": {
      "username": "shop-api",
      "password": "••••c123"
    },
    "ffd": ${ffd},
    "ffd_keys": ${ffdKeys}
  },
  "error": null
}`

const sberFfdKeys = `{
      "is_acquiring_receipt": false,
      "vat": "vat22",
      "sno": "usn_income",
      "inn": "7701234567",
      "email": "shop@example.com",
      "payment_address": "https://shop.example.com"
    }`

const masks = 'Секретные ключи шлюза (пароли, секретные ключи) приходят маской «••••» и четырьмя последними знаками; остальные ключи — как есть.'

const errors: ApiDocBlock = {
  id: 'errors',
  heading: 'Ошибки',
  text: [
    '422 — ошибка проверки: в error.message — первая ошибка, в error.errors — все ошибки по полям.',
    '404 — эквайринга с таким id нет.',
    '401 — нет токена руководителя или он устарел.',
  ],
  code: `{
  "success": 0,
  "data": null,
  "error": {
    "message": "<текст первой ошибки>",
    "errors": {
      "password": ["<текст ошибки>"]
    }
  }
}`,
}

export const acquiringApiDocs: Record<string, ApiDocPage> = {
  acquiringGates: {
    link: ['GET /api/dashboard/v1/chief/acquiring/gates'],
    blocks: [
      {
        id: 'about',
        heading: 'Описание',
        text: [
          'Методы этого раздела — методы кабинета: их вызывает руководитель компании с токеном входа в кабинет (Authorization: Bearer).',
          'Метод возвращает шлюзы, которые можно подключить. name — значение для поля name при создании эквайринга и для адреса «Поля для фискализации». keys — ключи шлюза, которые нужно передать при создании.',
        ],
      },
      {
        id: 'success',
        heading: 'Пример ответа',
        text: ['В примере показаны не все шлюзы.'],
        code: `{
  "success": 1,
  "data": [
    { "name": "Sber", "keys": ["username", "password"] },
    { "name": "Tbank", "keys": ["terminal_key", "terminal_password"] },
    { "name": "Yookassa", "keys": ["shop_id", "secret_key"] },
    { "name": "Robokassa", "keys": ["merchant_login", "password1", "password2"] }
  ],
  "error": null
}`,
      },
    ],
  },

  acquiringFfdKeys: {
    link: ['GET /api/dashboard/v1/chief/acquiring/ffd-keys/:gate'],
    blocks: [
      {
        id: 'about',
        heading: 'Описание',
        text: [
          ':gate — name шлюза из «Списка шлюзов», с учётом регистра (например, Sber). Неизвестный шлюз — 404.',
          'Метод возвращает поля фискализации для каждой версии ФФД (1.05 и 1.2) и правила их проверки. Состав полей и допустимые значения у шлюзов разные — смотрите их для своего шлюза.',
          'is_acquiring_receipt обязательно всегда. Остальные поля с правилом required_if_declined:is_acquiring_receipt обязательны, только если is_acquiring_receipt = false.',
        ],
      },
      {
        id: 'success',
        heading: 'Пример ответа для Sber',
        nav: 'Пример ответа',
        code: `{
  "success": 1,
  "data": {
    "1.05": {
      "is_acquiring_receipt": ["required", "boolean"],
      "vat": [
        "required_if_declined:is_acquiring_receipt",
        "nullable",
        "in:none,vat0,vat5,vat7,vat10,vat20,vat22,vat105,vat107,vat110,vat120,vat122"
      ],
      "sno": ["required_if_declined:is_acquiring_receipt", "in:osn,usn_income,usn_income_outcome,esn,patent"],
      "inn": ["required_if_declined:is_acquiring_receipt", "regex:/^\\\\d{10}|\\\\d{12}$/"],
      "email": ["required_if_declined:is_acquiring_receipt", "email:rfc,dns"],
      "payment_address": ["required_if_declined:is_acquiring_receipt", "url"]
    },
    "1.2": {
      "is_acquiring_receipt": ["required", "boolean"],
      "vat": [
        "required_if_declined:is_acquiring_receipt",
        "in:none,vat0,vat5,vat7,vat10,vat20,vat22,vat105,vat107,vat110,vat120,vat122"
      ],
      "sno": ["required_if_declined:is_acquiring_receipt", "in:osn,usn_income,usn_income_outcome,esn,patent"],
      "inn": ["required_if_declined:is_acquiring_receipt", "regex:/^\\\\d{10}|\\\\d{12}$/"],
      "email": ["required_if_declined:is_acquiring_receipt", "email:rfc,dns"],
      "payment_address": ["required_if_declined:is_acquiring_receipt", "url"]
    }
  },
  "error": null
}`,
      },
    ],
  },

  createAcquiring: {
    link: ['POST /api/dashboard/v1/chief/acquiring'],
    blocks: [
      {
        id: 'params',
        heading: 'Параметры',
        text: [
          'name — один из шлюзов «Списка шлюзов». Кроме него передаются все ключи этого шлюза (поле keys в списке) — все обязательны, строки.',
          'Фискализация при создании не настраивается: ffd и поля фискализации в этом запросе не сохраняются. Настройте её после создания методом «Обновление эквайринга».',
        ],
        code: `{
  "name": "Sber",          // обязательно; name из «Списка шлюзов»
  "username": "shop-api",  // ключи шлюза Sber — все обязательны
  "password": "secret-c123"
}`,
      },
      {
        id: 'success',
        heading: 'Пример ответа',
        text: [masks, 'Сразу после создания ffd и ffd_keys — null: фискализация не настроена.'],
        code: acquiringResponse('null', 'null'),
      },
      errors,
    ],
  },

  updateAcquiring: {
    link: ['PUT /api/dashboard/v1/chief/acquiring/:id'],
    blocks: [
      {
        id: 'params',
        heading: 'Параметры',
        text: [
          'Все поля не обязательны. Шлюз эквайринга не меняется: name можно не передавать.',
          'Ключи шлюза: новое значение заменяет прежнее. Не присланный ключ или маска «••••…» из ответа — ключ не меняется.',
        ],
        code: `{
  "password": "new-secret",              // ключ шлюза; не прислан или маска — остаётся прежний
  "ffd": "1.2",                          // версия ФФД: "1.05" или "1.2"
  "is_acquiring_receipt": false,         // поля ниже — из «Полей для фискализации» своего шлюза
  "vat": "vat22",
  "sno": "usn_income",
  "inn": "7701234567",
  "email": "shop@example.com",
  "payment_address": "https://shop.example.com"
}`,
      },
      {
        id: 'fiscalization',
        heading: 'Фискализация',
        text: [
          'Поля фискализации и правила их проверки зависят от шлюза и версии ФФД — берите их из «Полей для фискализации» для своего шлюза.',
          'ffd передан — фискализация настраивается заново: сохраняется версия и присланные поля этой версии, прежние поля заменяются. Поля проверяются по правилам выбранной версии.',
          'ffd не передан, is_acquiring_receipt: true — фискализация выключается: ffd и ffd_keys становятся null.',
          'ffd не передан и is_acquiring_receipt не true — фискализация не меняется. Так можно менять ключи шлюза, не трогая её.',
          'Данные для чека (состав заказа и НДС) передаются в банк, только если задана версия ФФД, is_acquiring_receipt = false и у компании не подключена своя онлайн-касса для чеков по онлайн-оплате.',
        ],
      },
      {
        id: 'success',
        heading: 'Пример ответа',
        text: [masks, 'ffd_keys — поля фискализации в том виде, в каком их прислали.'],
        code: acquiringResponse('"1.2"', sberFfdKeys),
      },
      errors,
    ],
  },

  getAcquiring: {
    link: ['GET /api/dashboard/v1/chief/acquiring/:id'],
    blocks: [
      {
        id: 'success',
        heading: 'Пример ответа',
        text: [
          ':id — id эквайринга из ответа на создание или из списка.',
          `${masks} Маску можно прислать обратно в «Обновлении эквайринга» — ключ не изменится.`,
          'ffd и ffd_keys — null, если фискализация не настроена.',
        ],
        code: acquiringResponse('"1.2"', sberFfdKeys),
      },
      errors,
    ],
  },

  acquiringList: {
    link: ['GET /api/dashboard/v1/chief/acquiring'],
    blocks: [
      {
        id: 'params',
        heading: 'Параметры',
        text: [
          'Параметры строки запроса, оба не обязательны: page — номер страницы (по умолчанию 1), per_page — сколько записей на странице (по умолчанию 15).',
          'Список отсортирован по названию шлюза. Ключи и фискализация в списке не выводятся — их показывает «Показать эквайринг».',
        ],
        code: 'GET /api/dashboard/v1/chief/acquiring?page=1&per_page=15',
      },
      {
        id: 'success',
        heading: 'Пример ответа',
        code: `{
  "success": 1,
  "data": {
    "data": [
      { "id": 2, "name": "Sber" },
      { "id": 3, "name": "Tbank" }
    ],
    "pagination": {
      "current_page": 1,
      "per_page": 15,
      "total": 2,
      "total_pages": 1
    }
  },
  "error": null
}`,
      },
    ],
  },

  deleteAcquiring: {
    link: ['DELETE /api/dashboard/v1/chief/acquiring/:id'],
    blocks: [
      {
        id: 'success',
        heading: 'Пример ответа',
        text: [':id — id эквайринга из ответа на создание или из списка.'],
        code: `{
  "success": 1,
  "data": {
    "message": "ok"
  },
  "error": null
}`,
      },
      errors,
    ],
  },
}
